import Button from "components/Button";
import { useTranslation } from "react-i18next";

const HeroSection = ({ search, setSearch, save, setSave }) => {
  const { t } = useTranslation("home");

  return (
    <div className="flex justify-center items-center flex-col w-full mt-[6rem] md:mt-[10rem] mb-[5rem]">
      <div className="flex justify-center items-center flex-col gap-5">
        <h2 className="font-lexend font-semibold text-[36px] md:text-[52px] w-[90%] md:w-[80%] lg:w-[60%] text-black text-center md:leading-[56px]">
          {t("blog.header.title")}
        </h2>
        <p className="text-xl text-[#00000066] font-normal text-center md:text-left">
          Stay updated with our latest news and announcements.
        </p>

        <div className="pt-10 w-[600px] max-md:mx-auto max-sm:w-[90%] max-[400px]:w-full">
          <div className=" w-full flex items-center justify-start gap-3 border-[#202D66] border rounded-full px-3 py-1 relative">
            <input
              className="font-lexend h-10 pl-3 bg-transparent border-0 rounded-md flex-1 max-[450px]:w-full placeholder:text-[#00000066] text-[#00000066] text-sm focus:outline-none focus:bg-transparent"
              type="text"
              value={search}
              onChange={(event) => {
                if (save) {
                  setSave(false);
                }
                setSearch(event.target.value);
              }}
              onKeyDown={(event) => {
                if (event?.key === "Enter") {
                  setSave(true);
                }
              }}
              placeholder={t("blog.header.emailPlaceholder")}
            />
            <div className="absolute right-0">
              <Button
                text={t("blog.header.emailButton")}
                className="!px-8 !py-3"
                onClick={() => setSave(true)}
                size="lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HeroSection;
